// DSS Documentation on Angular - http://tiny.sc/cgangular
// DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// DSS Documentation on SocoModalService - http://tiny.sc/cgsocomodalservice
import { SocoModalService } from '@soco/modal';

import { WebApiConfigService } from './web-api-config.service';

@Component({
    selector: 'web-api-config',
    templateUrl: 'web-api-config.component.html'
})
export class WebApiConfigComponent implements OnInit, OnDestroy {
    alertId = 'alert-web-api-config';
    modalId = 'modal-web-api-config';
    form: FormGroup;

    private unsubscribe$ = new Subject<void>();

    constructor(
        private webApiConfigService: WebApiConfigService,
        private socoModalService: SocoModalService,
        private formBuilder: FormBuilder
    ) { }

    ngOnInit() {
        this.form = this.formBuilder.group(new WebApiConfig());

        this.webApiConfigService.openModal$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                this.openModal();
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    openModal() {
        this.form.get('webApiBaseUrl').setValue(sessionStorage.getItem('webApiBaseUrl'));

        this.socoModalService.show({
            id: this.modalId
        });
    }

    formSubmitted(webApiConfig: WebApiConfig): void {
        webApiConfig.webApiBaseUrl += webApiConfig.webApiBaseUrl[webApiConfig.webApiBaseUrl.length - 1] !== '/' ? '/' : '';
        sessionStorage.setItem('webApiBaseUrl', webApiConfig.webApiBaseUrl);
        sessionStorage.setItem('webApiToken', webApiConfig.webApiToken);
        window.location.reload();
    }
}

class WebApiConfig {
    webApiBaseUrl = '';
    webApiToken = '';
}

